module.exports = __webpack_public_path__ + "img/double.828e77cd.svg";